import { useMemo } from 'react';

import { usePropertySchema } from '@/lib/crm/hooks/usePropertySchema';

import type { AhoyPropertyOption } from '../types';

export function useAvailableContactProperties(
  orgId: number | string | undefined
): AhoyPropertyOption[] {
  const { schema } = usePropertySchema(orgId ?? '', 'ahoy_contact');

  return useMemo(
    () =>
      Object.values(schema ?? {})
        .filter(
          p =>
            p.value_write_access !== 'none' &&
            p.value_write_access !== 'internal'
        )
        .map(p => ({
          name: p.property_type_name,
          label: p.label,
          fieldType: p.field_type_name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [schema]
  );
}
